export default "__VITE_ASSET___sgcKW_k__"